import config from '../../app/config';

const now = () => {
    return new Date().getTime() / 1000;
};

const humanFileSize = (size) => {
    var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return +((size / Math.pow(1024, i)).toFixed(2)) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
};

class ImageCache {
    constructor() {
        this.cfg = {
            ttl: config.modules.viewer.cache?.ttl || -1,
            amount: config.modules.viewer.cache?.amount || -1,
            size: config.modules.viewer.cache?.size || -1,
        };
        this.dataDict = {};
        this.dataArray = [];

        if (this.cfg.ttl > 0) {
            this.intervalId = setInterval(() => {
                this._trim(this);
            }, 30 * 1000);
        }
    }

    set(key, imageOrPromise) {
        console.debug(`imageCache - add ${key} ${Object.prototype.toString.call(imageOrPromise)}`);
        if (!key) return;

        let entry = new CacheEntry(now() + this.cfg.ttl, imageOrPromise.sizeInBytes || 0, key, imageOrPromise);
        this.dataDict[key] = entry;

        let idx = this.dataArray.findIndex(ce => ce.key === key);
        if (idx > -1) {
            this.dataArray.splice(idx, 1);
        }
        this.dataArray.push(entry);

        let totalSize = this.dataArray.reduce((accumulator, ce) => {
            return accumulator + ce.size;
        }, 0);
        console.debug(`imageCache - amount: ${this.dataArray.length} totalSize: ${humanFileSize(totalSize)}`);
        if (this.cfg.size > 0) {
            while (totalSize > this.cfg.size && this.dataArray.length > 1) {
                totalSize -= this.dataArray[0].size;
                this.remove(this.dataArray[0].key);
            }
        }

        if (this.cfg.amount > 0 && this.dataArray.length > this.cfg.amount) {
            this.remove(this.dataArray[0].key);
        }
    }

    get(key) {
        if (!key) return;

        let idx = this.dataArray.findIndex(ce => ce.key === key);
        if (idx > -1) {
            const entry = this.dataArray[idx];
            this.dataArray.splice(idx, 1);
            this.dataArray.push(entry);

            entry.ttl = now() + this.cfg.ttl;
        }

        return this.dataDict[key]?.value;
    }

    has(key) {
        return this.dataDict.hasOwnProperty(key);
    }

    remove(key) {
        if (!key) return;
        console.debug(`imageCache - remove ${key}`);
        delete this.dataDict[key];
        let idx = this.dataArray.findIndex(ce => ce.key === key);
        if (idx > -1) {
            this.dataArray.splice(idx, 1);
        }
    }

    clean() {
        console.debug(`imageCache - clean`);
        for (let key in this.dataDict) {
            if (this.dataDict.hasOwnProperty(key)) {
                this.remove(key);
            }
        }
    }

    dispose() {
        this.dataDict = null;
        this.dataArray = null;
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    _expired(entryTime, curr) {
        if (this.cfg.ttl <= 0) {
            return false;
        }
        if (!curr) {
            curr = now();
        }
        return entryTime < curr;
    };

    _trim(imageCache) {
        console.debug(`imageCache - trim`);
        let curr = now();
        for (let key in imageCache.dataDict) {
            if (imageCache.dataDict.hasOwnProperty(key)) {
                if (imageCache._expired(imageCache.dataDict[key].expires, curr)) {
                    imageCache.remove(key);
                }
            }
        }
    };
}

class CacheEntry {
    constructor(expires, size, key, value) {
        this.expires = expires;
        this.size = size;
        this.key = key;
        this.value = value;
    }
}

const globalImageCache = new ImageCache();

export {ImageCache, globalImageCache};